import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const Chart = () => {
    const highchartsArgs = {
        chart: {
            height: 250,
        },
        title: {
            text: '',
            x: -20, // center
        },
        subtitle: {
            text: '',
            x: -20,
        },
        xAxis: {
            categories: [
                '1950',
                '1960',
                '1970',
                '1980',
                '1990',
                '2000',
                '2010',
                '2020',
                '2030',
                '2040',
                '2050',
            ],
            plotBands: [
                {
                    color: '#eeece4',
                    from: 6.5,
                    to: 10,
                    id: 'plotband-1',
                },
            ],
        },
        credits: { enabled: false },
        exporting: { enabled: false },
        legend: {
            enabled: false,
        },
        yAxis: {
            title: {
                text: '',
            },
            plotLines: [
                {
                    value: 0,
                    width: 1,
                    color: '#808080',
                },
            ],
        },
        tooltip: {
            valueSuffix: '%',
        },
        plotOptions: {
            line: {
                marker: {
                    enabled: false,
                },
            },
        },
        legend: {
            layout: '',
            align: '',
            verticalAlign: '',
            borderWidth: 0,
        },
        series: [
            {
                name: 'U.S.',
                color: '#436983  ',
                data: [
                    8.3,
                    9.2,
                    9.8,
                    11.3,
                    12.5,
                    12.4,
                    13.1,
                    16.6,
                    20.2,
                    21.2,
                    21.5,
                ],
            },
            {
                name: 'Germany',
                color: '#d3aa34  ',
                data: [
                    9.6,
                    11.5,
                    13.6,
                    15.6,
                    15.0,
                    16.3,
                    20.8,
                    23.1,
                    28.2,
                    31.8,
                    32.7,
                ],
            },
            {
                name: 'Italy',
                color: '#949D48  ',
                data: [
                    8.1,
                    9.5,
                    11.1,
                    13.4,
                    14.9,
                    18.3,
                    20.3,
                    22.8,
                    26.8,
                    31.7,
                    33.0,
                ],
            },
        ],
    };
    return (
        <div id="second-chart" className="second-tabbed-content">
            <div id="second-chart-bkgd">
                <div id="tooltip">
                    In <strong>2015</strong>, Germany and Italy are already at a
                    level the U.S. may reach in 2050.
                </div>
                <div id="projected-label">projected</div>
                <div id="second-chart-container">
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={highchartsArgs}
                    />
                </div>
            </div>

            <div id="country-labels">
                <div className="labels">
                    <span style={{ color: '#d3aa34', fontWeight: '800' }}>
                        &mdash;&mdash;&mdash;&nbsp;
                    </span>
                    Germany
                    <br />
                    <br />
                    <span style={{ color: '#5b8e83', fontWeight: '800' }}>
                        &mdash;&mdash;&mdash;&nbsp;
                    </span>
                    Italy
                    <br />
                    <br />
                    <span style={{ color: '#436983', fontWeight: '800' }}>
                        &mdash;&mdash;&mdash;&nbsp;
                    </span>
                    U.S.
                </div>
            </div>
        </div>
    );
};

export default Chart;
